import { componentName } from "./const";
import { View } from "./view";
export { generateEffects } from "./utils";
var Index = View;
Index.displayName = componentName;
export default Index;